import styled from 'styled-components';
import { colors } from '../../utils/constants';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const AccessControlHeader = styled.div`
  width: 100%;
  display: flex;
  padding: 20px;
  margin-bottom: 20px;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 5px;
  box-shadow: 1px 2px 2px 2px ${colors.grey};
  background-color: white;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    justify-content: space-between;
  }
`;
